// @ts-expect-error svgs are untyped modules
import blobsImageUrl from 'bender-url!ecosystem-marketplace-solutions-base/img/explainer-blob.svg';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H7 } from 'foundations-components/transitional/components/H7';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSectionInner';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BADGE_HEIGHT = '20px';
const StyledExplainerWrapper = styled.div.withConfig({
  displayName: "StorefrontExplainer__StyledExplainerWrapper",
  componentId: "sc-121708f-0"
})(["display:flex;flex-direction:row;background-color:", ";background-image:url(", ");background-position:center center;background-repeat:no-repeat;background-size:auto 150%;padding:", ";"], ({
  theme
}) => theme.color['fill-surface-raised'], blobsImageUrl, ({
  theme
}) => `${theme.space['1000']} ${theme.space['1400']}`);
const StyledStepNumberBadge = styled.div.withConfig({
  displayName: "StorefrontExplainer__StyledStepNumberBadge",
  componentId: "sc-121708f-1"
})(["display:inline-block;flex-shrink:0;background-color:", ";color:", ";mix-blend-mode:multiply;height:", ";width:", ";line-height:", ";text-align:center;border-radius:50%;font-weight:500;margin-right:", ";"], ({
  theme
}) => theme.color['fill-accent-purple-default'], ({
  theme
}) => theme.color['text-core-on-fill-default'], BADGE_HEIGHT, BADGE_HEIGHT, BADGE_HEIGHT, ({
  theme
}) => theme.space['300']);
const StyledCopyWrapper = styled.div.withConfig({
  displayName: "StorefrontExplainer__StyledCopyWrapper",
  componentId: "sc-121708f-2"
})(["max-width:250px;"]);
const StorefrontExplainer = () => {
  const {
    illustrationStyles,
    showIllustration
  } = useResponsiveProps({
    illustrationStyles: {
      lg: {
        marginInlineStart: '1500'
      },
      xs: {
        marginInlineStart: '600'
      }
    },
    showIllustration: {
      lg: true,
      md: false,
      xs: true
    }
  });
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledExplainerWrapper, {
      children: /*#__PURE__*/_jsx(MainSectionInner, {
        children: /*#__PURE__*/_jsxs(Flex, {
          flexGrow: 0,
          flexDirection: "column",
          alignItems: "start",
          children: [/*#__PURE__*/_jsx(View, {
            borderBlockEndStyle: "solid",
            borderBlockEndWidth: "200",
            borderBlockEndColor: "fill-accent-blue-default",
            paddingBlockEnd: "200",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(Text, {
              as: "h1",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "ecosystem-marketplace-solutions-ui.homepage.explainer.title"
              })
            })
          }), /*#__PURE__*/_jsxs(Grid, {
            children: [/*#__PURE__*/_jsxs(GridItem, {
              size: {
                xs: 12,
                md: 4,
                lg: 3
              },
              display: "flex",
              marginBlockStart: "400",
              children: [/*#__PURE__*/_jsx(StyledStepNumberBadge, {
                children: "1"
              }), /*#__PURE__*/_jsxs(StyledCopyWrapper, {
                children: [/*#__PURE__*/_jsx(H7, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "ecosystem-marketplace-solutions-ui.homepage.explainer.stepOne.title"
                  })
                }), /*#__PURE__*/_jsx("p", {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "ecosystem-marketplace-solutions-ui.homepage.explainer.stepOne.description"
                  })
                })]
              })]
            }), /*#__PURE__*/_jsxs(GridItem, {
              size: {
                xs: 12,
                md: 4,
                lg: 3
              },
              display: "flex",
              marginBlockStart: "400",
              children: [/*#__PURE__*/_jsx(StyledStepNumberBadge, {
                children: "2"
              }), /*#__PURE__*/_jsxs(StyledCopyWrapper, {
                children: [/*#__PURE__*/_jsx(H7, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "ecosystem-marketplace-solutions-ui.homepage.explainer.stepTwo.title"
                  })
                }), /*#__PURE__*/_jsx("p", {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "ecosystem-marketplace-solutions-ui.homepage.explainer.stepTwo.description"
                  })
                })]
              })]
            }), /*#__PURE__*/_jsxs(GridItem, {
              size: {
                xs: 12,
                md: 4,
                lg: 3
              },
              display: "flex",
              marginBlockStart: "400",
              children: [/*#__PURE__*/_jsx(StyledStepNumberBadge, {
                children: "3"
              }), /*#__PURE__*/_jsxs(StyledCopyWrapper, {
                children: [/*#__PURE__*/_jsx(H7, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "ecosystem-marketplace-solutions-ui.homepage.explainer.stepThree.title"
                  })
                }), /*#__PURE__*/_jsx("p", {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "ecosystem-marketplace-solutions-ui.homepage.explainer.stepThree.description"
                  })
                })]
              })]
            }), showIllustration && /*#__PURE__*/_jsx(GridItem, {
              size: {
                xs: 12,
                lg: 3
              },
              children: /*#__PURE__*/_jsx(Illustration, {
                inlineSize: "150px",
                name: "approvals",
                marginInlineStart: illustrationStyles === null || illustrationStyles === void 0 ? void 0 : illustrationStyles.marginInlineStart
              })
            })]
          })]
        })
      })
    })
  );
};
export default StorefrontExplainer;